// extracted by mini-css-extract-plugin
module.exports = {"worker-list":"JobDetailStageWorkers_worker-list_3vv0F","worker":"JobDetailStageWorkers_worker_3ILyi"};